import React, { useEffect } from 'react';
import {
  Dialog,
  IconButton,
  Typography,
  DialogBody,
  DialogHeader,
  DialogFooter,
} from '@material-tailwind/react';

import { XMarkIcon } from '@heroicons/react/24/outline';
import { useForm } from 'react-hook-form';
import ButtonGlobal from '../ButtonGlobal';
import MsgSucess from '../MsgSucess';
import ButtonDinamic from '../ButtonDinamic';
import { usePatchPecas } from '../../hook/getPecas';
import { useErroControlManul } from '../../hook/useErroControlManul';

export function EditModalInputs({ modal, handleModal, item, setNewPec }) {
  const {
    register,
    handleSubmit,
    clearErrors,
    watch,
    setValue,
    setError,
    formState: { errors },
  } = useForm();
  const watchQtd = watch('quantidade');
  const { result, patch, resetResult } = usePatchPecas();
  const { useArrayErrorForm } = useErroControlManul();

  useEffect(() => {
    setValue('quantidade', item.quantidade);
  }, []);

  const onSubmit = (data) => {
    patch(data, item.id);
    setNewPec(true);
  };

  const resetInfo = () => {
    handleModal();
    resetResult();
    clearErrors();
  };

  useEffect(() => {
    if (result.error) {
      useArrayErrorForm(result.error, setError);
    }
  }, [result]);

  return (
    <>
      <Dialog
        size="sm"
        open={modal}
        handler={resetInfo}
        className={`p-4 bg-lightMenu dark:bg-none dark:bg-darkColorBg`}
      >
        <DialogHeader className="relative m-0 block">
          <Typography variant="h4" color="black" className="dark:text-darkText">
            Alterando - {item.produto}
          </Typography>
          <IconButton
            size="sm"
            variant="text"
            color="white"
            className="!absolute right-3.5 top-3.5"
            onClick={resetInfo}
          >
            <XMarkIcon className="h-4 w-4 stroke-2" />
          </IconButton>
        </DialogHeader>
        <DialogBody className="space-y-4 pb-6">
          <form className="flex flex-col gap-5">
            <div>
              <ButtonDinamic
                formCamp="nome"
                type="text"
                label="Nome"
                register={register}
                errors={errors?.nome ? errors : false}
                valor={item.produto}
                cssDiv="w-full"
                disabled
              />
            </div>
            <div>
              <ButtonDinamic
                formCamp="produtoWinthor"
                type="text"
                label="Codigo"
                register={register}
                errors={errors?.produtoWinthor ? errors : false}
                valor={item.produtoWinthor}
                cssDiv="w-full"
                disabled
              />
            </div>
            <div>
              <ButtonDinamic
                placeholder={'Digite quantidade utilizada'}
                formCamp="quantidade"
                patch
                type="number"
                label="Quantidade"
                register={register}
                validations={{ required: true }}
                required={true}
                errors={errors?.quantidade ? errors : false}
                valor={watchQtd}
                cssDiv="w-full"
              />
            </div>
          </form>
        </DialogBody>
        <DialogFooter>
          <ButtonGlobal
            className="ml-auto"
            click={handleSubmit(onSubmit)}
            color="blue"
            text={'Salvar'}
          />
        </DialogFooter>
        {result?.produto && (
          <MsgSucess reset={resetInfo} outText="Salvom com sucesso" text={item.nome} />
        )}
      </Dialog>
    </>
  );
}
